import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: "home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index1.vue"),
      },
      {
        path: "cpzx",
        name: "cpzx",
        component: () => import("@/views/chanpinzhongxin/index.vue"),
      },
      {
        path: "info",
        name: "info",
        component: () => import("@/views/chanpinzhongxin/info.vue"),
      },
      {
        path: "zhfa",
        name: "zhfa",
        component: () => import("@/views/zhihuifangan/index.vue"),
      },
      {
        path: "gywm",
        name: "gywm",
        component: () => import("@/views/guanyuwomen/index.vue"),
      },
      {
        path: "swhz",
        name: "swhz",
        component: () => import("@/views/shangwuhezuo/index.vue"),
      },
      {
        path: "xwzx",
        name: "xwzx",
        component: () => import("@/views/xinwenzixun/index.vue"),
      },
      {
        path: "centerInfo",
        name: "centerInfo",
        component: () => import("@/views/xinwenzixun/centerInfo.vue"),
      },
    ],
  },
];

// ========== 新增核心代码：重写 push/replace 方法，解决重复导航错误 ==========
// 保存原始的 push 方法
const originalPush = VueRouter.prototype.push;
// 重写 push 方法
VueRouter.prototype.push = function push(location) {
  // 调用原始 push 方法，并捕获重复导航的异常
  return originalPush.call(this, location).catch((err) => {
    // 只忽略 NavigationDuplicated 异常，其他错误正常抛出
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

// 可选：重写 replace 方法（防止 replace 也触发相同错误）
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};
// ========== 新增代码结束 ==========

// 滚动行为配置（保留你原有的逻辑）
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition && to.meta.keepAlive) {
    return savedPosition;
  }
  return {
    left: 0,
    top: 0,
  };
};

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === "gywm") {
      return;
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

export default router;